import * as React from 'react';
import { Avatar } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useSearchParams } from "react-router-dom";
import Box from '@mui/material/Box';
import SimpleLogin from '../SimpleLogin';

const MyLoginPage = () => {
    const [searchParams,] = useSearchParams();
    const isCreate = searchParams.get('create') !== null
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                alignItems: 'center',
                justifyContent: 'flex-start',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundImage:
                    'radial-gradient(circle at 50% 14em, #313264 0%, #00023b 60%, #00023b 100%)',
            }}
        >
            <Box sx={{ minWidth: 300, marginTop: '10em' }}>
                <Box
                    sx={{
                        margin: '1em',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Avatar sx={{ bgcolor: 'secondary.main', width: 72, height: 72 }}>
                        <LockIcon sx={{ fontSize: 36 }} />
                    </Avatar>
                </Box>
                <Box sx={{
                        margin: '2em',
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                    <SimpleLogin initialMode={isCreate ? 'signup' : 'signin'}/>
                </Box>
            </Box>
        </Box>
    );
};

export default MyLoginPage;
